import React, { useState } from 'react';

type Props = {};

const ChangePasswordPage = (props: Props) => {
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPasswordData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert("New password and confirm password don't match!");
      return;
    }
    console.log('Password Changed:', passwordData);
  };

  const containerStyle = {
    maxWidth: '100%',
    margin: '0 auto',
    padding: '20px',
    borderRadius: '8px',
    
  };

  const inputStyle = {
    width: '40%',
    padding: '8px',
    marginBottom: '15px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '12px',
    backgroundColor:'#F5F5F5'
  };

  const buttonStyle = {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#1173B7',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    width: '40%',
  };

  const labelStyle = {
    fontSize: '12px',
    marginBottom: '5px',
    display: 'block',
  };

  const titleStyle = {
    fontSize: '12px',
    marginBottom: '20px',
    textAlign: 'left' as const,
  };

  return (

    <div style={containerStyle}>


<div style={{width:'60%', textAlign:'left',boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)' , padding:'30px', height:'500px'}}>
      <h2 style={titleStyle}>Change Password</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="oldPassword" style={labelStyle}>
            Old Password: <span style={{ fontSize: '12px', color: 'gray' }}>(Min 6 characters)</span>
          </label>
          <input
            id="oldPassword"
            type="password"
            name="oldPassword"
            value={passwordData.oldPassword}
            onChange={handleInputChange}
            required
            // placeholder="Enter your old password"
            style={inputStyle}
            minLength={6}
          />
        </div>

        <div>
          <label htmlFor="newPassword" style={labelStyle}>
            New Password: <span style={{ fontSize: '12px', color: 'gray' }}>(Min 6 characters)</span>
          </label>
          <input
            id="newPassword"
            type="password"
            name="newPassword"
            value={passwordData.newPassword}
            onChange={handleInputChange}
            required
            // placeholder="Enter your new password"
            style={inputStyle}
            minLength={6}
          />
        </div>

        <div>
          <label htmlFor="confirmPassword" style={labelStyle}>
            Confirm New Password: <span style={{ fontSize: '12px', color: 'gray' }}>(Min 6 characters)</span>
          </label>
          <input
            id="confirmPassword"
            type="password"
            name="confirmPassword"
            value={passwordData.confirmPassword}
            onChange={handleInputChange}
            required
            // placeholder="Re-enter your new password"
            style={inputStyle}
            minLength={6}
          />
        </div>

        <button type="submit" style={buttonStyle}>
          Update
        </button>
      </form>
    </div>



    </div>
    
  );
};

export default ChangePasswordPage;
